import {
  Box
} from '@mui/material'

import { useContext } from 'react'

// Context
import { InventoryDataContext, InventoryDispatchContext } from 'src/store/inventory/Store'
import { ItemDataContext } from 'src/store/items/Store'

// Components
import ItemBlock from 'src/components/common/ItemBlock'
import { setQuantity } from 'src/store/inventory/actions'
import { StatsDataContext } from 'src/store/stats/Store'

const container = {
  display: 'flex',
  width: '100%',
  maxHeight: '32px'
}

const wrapper = {
  width: '324px',
  display: 'flex',
  flexDirection: 'row',
  overflow: 'scroll',
  gap: '16px'
}

const Loot = () => {
  const { items } = useContext(ItemDataContext)
  const { stats } = useContext(StatsDataContext)
  const { inventory } = useContext(InventoryDataContext)
  const { dispatchInventory } = useContext(InventoryDispatchContext)

  const handleLoot = (itemID: string) => {
    if (stats.total.kg + items[itemID].weight <= stats.total.kg_max + stats.total.player_vit * 5) {
      setQuantity(dispatchInventory, 'bag', itemID, { '+': 1 })
      setQuantity(dispatchInventory, 'loot', itemID, { '-': 1 })
    }
  }

  // change color of loot to red if overburdened
  const filteredItemIDs = Object.keys(inventory.loot).filter(itemID => inventory.loot[itemID] > 0)

  return (
    <Box sx={container} className='loot'>
      <Box sx={wrapper} className='items'>
        {filteredItemIDs.length ? (
          filteredItemIDs.map((inventoryItemID) => (
            new Array(inventory.loot[inventoryItemID]).fill('').map((_, index) => (
              <ItemBlock key={index} item={items[inventoryItemID]} handleClick={handleLoot} color={ (stats.equipped.kg + items[inventoryItemID].weight) > (stats.equipped.kg_max + stats.total.player_vit * 5) ? 'crimson' : 'white'}/>
            ))
          ))
        ) : (
          <ItemBlock handleClick={() => {}} />
        )}
      </Box>
    </Box>
  )
}

export default Loot
